export default "__VITE_ASSET__BfoUoc52__"